<script lang="ts">
  import type { Product, ProductLine } from "@shared/types/ProductLine";
  import Icon from "@shared/svelte/Components/Icon.svelte";
  import FuturePricesStore from "@shared/svelte/Stores/FuturePricesStore.js";
  import { get as getStoreValue } from "svelte/store";
  import FuturePricesModal from "@retailer/svelte/ProductDetails/Components/FuturePricesModal.svelte";
  import MinBottlePricingModal from "@retailer/svelte/ProductDetails/Components/MinBottlePricingModal.svelte";
  import StateSettingsStore from "@shared/svelte/Stores/StateSettingsStore";

  export let product: Product;
  export let productLine: ProductLine;
  export let showPricingModal: boolean = false;

  // For use on PLP list view
  export let futurePricesData: any = null;
  export let justifyEnd: boolean = true;
  export let onOpenModal: () => void = () => {};
  export let onCloseModal: () => void = () => {};

  const stateSettings = getStoreValue(StateSettingsStore);

  function openModal() {
    showPricingModal = true;
    onOpenModal();
  }

  let priceChange = "";
  let pricingForProduct;
  $: futurePrices = futurePricesData || $FuturePricesStore;
  $: showFuturePrices = futurePrices.length > 0;
  $: {
    if (showFuturePrices) {
      pricingForProduct = futurePrices?.find(p => p.inventory_id === product.inventory_id);
      if (pricingForProduct) {
        priceChange = pricingForProduct["price_change"];
      }
    }
  }

</script>

{#if showFuturePrices && priceChange.length > 0}
  <div class="fizz-flex-row-inline-4 fizz-text-subdued" class:fizz-justify-end={justifyEnd}>
    {#if priceChange === "up"}
      <Icon type="UpArrow" />
    {/if}
    {#if priceChange === "down"}
      <Icon type="DownArrow" />
    {/if}
    {#if priceChange === "up_and_down"}
      <Icon type="UpDownArrows" />
    {/if}
    <span
      id="open-future-prices"
      data-testid="open-future-prices"
      class="fizz-text-small underline cursor-pointer"
      on:click={openModal}
    >
      See price schedule
    </span>
  </div>
  {#if stateSettings["uses_future_pricing_with_min_bottle"] && productLine}
    <MinBottlePricingModal
      bind:showPricingModal
      {product}
      {productLine}
      {pricingForProduct}
      {onCloseModal}
    />
  {:else}
    <FuturePricesModal
      bind:showPricingModal
      {product}
      {productLine}
      {pricingForProduct}
      {onCloseModal}
    />
  {/if}
{/if}
